import { IntlShape } from 'react-intl';
import { CardType, DEPOSIT_CONFIRMATION_TYPE } from '../data-types/wallet/walletEnums';
import { enqueueNotification } from '../state/actions/dialogActions';
import {
  setDepositAmount,
  setDepositCardType,
  setDepositConfirmationType,
  setDepositNotificationContent,
} from '../state/actions/walletActions';
import { store } from '../state/store';

export const tryEnqueueDepositNotificationAndResetDepositInfo = (
  depositConfirmationType: DEPOSIT_CONFIRMATION_TYPE,
  title: string,
  body: string,
) => {
  if (depositConfirmationType === DEPOSIT_CONFIRMATION_TYPE.APP_NOTIFICATION) {
    enqueueNotification({
      title,
      body,
      image: undefined,
      background: undefined,
      url: undefined,
      depositNotification: true,
    });

    resetDepositInfo();
  }
};

export const resetDepositInfo = () => {
  const {
    wallet: { depositInfo },
  } = store.getState();
  const { depositConfirmationType, cardType, amount, appNotification } = depositInfo;

  if (depositConfirmationType !== DEPOSIT_CONFIRMATION_TYPE.THANK_YOU_CARD) {
    setDepositConfirmationType(DEPOSIT_CONFIRMATION_TYPE.THANK_YOU_CARD);
  }

  if (cardType !== CardType.DEPOSIT) {
    setDepositCardType(CardType.DEPOSIT);
  }

  if (amount !== 0) {
    setDepositAmount(0);
  }

  if (appNotification.title !== '' || appNotification.content !== '') {
    setDepositNotificationContent({ title: '', content: '' });
  }
};

export const forceSetDepositConfirmationTypeToThankYouCard = () => {
  setDepositConfirmationType(DEPOSIT_CONFIRMATION_TYPE.THANK_YOU_CARD);
};

export const setAppNotificationDepositData = (amount: number | undefined, currency: string, intl: IntlShape) => {
  const { formatMessage } = intl;

  if (amount) {
    const notificationTitle = formatMessage({ id: 'profile.wallet.deposit_success_title' });
    const notificationContent = formatMessage(
      { id: 'profile.wallet.deposit_success_message' },
      {
        amountWithCurrency:
          (amount &&
            formatMessage(
              { id: 'common.currencyValue' },
              {
                currency,
                value: amount,
              },
            )) ||
          '',
      },
    );
    setDepositAmount(amount);
    setDepositNotificationContent({ title: notificationTitle, content: notificationContent });
  }
};
